import { Injectable, inject, signal } from '@angular/core';
import { NzI18nInterface, NzI18nService } from 'ng-zorro-antd/i18n';
import { LoggingService } from './logging.service';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  public getLocalizedLabel(
    obj: { [x: string]: string | number | boolean | null | undefined },
    propertyName: string,
    lang = this.locale().locale,
  ): string {
    if (!obj || !propertyName) {
      this.logger.warn(`Root object and property are mandatory to get localized label`, obj, propertyName);
      return '';
    }

    if (lang === 'en') {
      if (!Object.prototype.hasOwnProperty.call(obj, propertyName)) {
        return obj[propertyName] as string;
      }

      return obj[propertyName] as string;
    } else if (lang === 'es' || lang === 'fr') {
      if (!Object.prototype.hasOwnProperty.call(obj, `${propertyName}_${lang}`)) {
        return obj[propertyName] as string;
      }

      return obj[`${propertyName}_${lang}`] as string;
    }

    throw new Error('Unsupported language ' + lang);
  }

  public async translateText(text: string, sourceLanguage: string, targetLanguage: string): Promise<string> {
    return this.API.post(environment.API_NAME, `/main/translate`, {
      body: { text, sourceLanguage, targetLanguage },
    });
  }

  private readonly logger = inject(LoggingService);
  private readonly i18n = inject(NzI18nService);
  private readonly API = inject(ApiService);

  public locale = signal<NzI18nInterface>(this.i18n.getLocale());
}
